import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=d2e52272&scoped=true"
import script from "./Licence.vue?vue&type=script&lang=js"
export * from "./Licence.vue?vue&type=script&lang=js"
import style0 from "./Licence.vue?vue&type=style&index=0&id=d2e52272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e52272",
  null
  
)

export default component.exports